import { Grid, Box } from "@mui/material";
import AdminApi from "../../../config/apis/admin";
import { useState } from "react";
import { Link } from "react-router-dom";
import CSVDownloadButton from "../../../components/downloadCSV";
// import FilterBase from "./filter/filter-base";
import { FriendsOfCGGrid } from "./FriendsOfCGTable";
import style from "./style.module.css";
import { HasPermission } from "../../../helper/helperFunction";
import FilterBase from "./filter/filter-base";

export const FriendsOfCGView = () => {
  const [filters, setFilters] = useState();

  const handleFiltersChange = (filterState) => {
    setFilters(filterState);
  };

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="container transaction_module">
        <div className="course-content">
          <h1 className="main-heading">Friends of CodeGirls</h1>

          <HasPermission permission="manage-friends-of-codegirls.create">
            <Box className={`btn-wrapper ${style.addFriendsOfCGBtn}`}>
              <Link
                to={"#"}
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Add a Friend
              </Link>
            </Box>
          </HasPermission>
        </div>

        <Grid
          container
          marginBottom={4}
          alignItems={"flex-start"}
          justifyContent={"space-between"}
        >
          <FilterBase onFiltersChange={handleFiltersChange} />
          <CSVDownloadButton
            apiEndpoint={AdminApi.FRIENDS_OF_CG_PAGINATION}
            params={"desc"}
            fileName={"FriendsOfCodeGirls"}
          />
        </Grid>

        <FriendsOfCGGrid
          filters={filters}
          currentValue={"desc"}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      </div>
    </>
  );
};
